<template>
  <div>
    <datatable
      title="Question Infos"
      @edit_click="editClick"
      :is_createable="false"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-questions',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'key',
          value: 'key'
        },
        {
          name: 'content',
          value: 'content'
        },
        {
          name: 'question_id',
          value: 'question_id'
        }
      ],
      data: [],
      operations: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getQuestionInfos({ question_id: this.$route.query.question_id }).then(response => {
        this.data = response
      })
    },
    editClick (data) {
      this.create({ designator: 'admin-question-infos-form-modal', component_name: 'AdminQuestionInfosForm', data, modal_title: data.key })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
